import axios from "axios";
import { gaEvent } from "./ga";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API, withCredentials: true });

// Silent access-token renewal: a 401 tries the 7-day refresh cookie once, then replays.
let renewal = null;
api.interceptors.response.use(undefined, async (error) => {
  const cfg = error.config || {};
  const url = cfg.url || "";
  const skip = url.includes("/auth/login") || url.includes("/auth/register") ||
               url.includes("/auth/refresh") || url.includes("/auth/logout");
  if (error.response?.status !== 401 || cfg._retried || skip) throw error;
  cfg._retried = true;
  try {
    renewal = renewal || api.post("/auth/refresh").finally(() => { renewal = null; });
    await renewal;
  } catch {
    throw error;
  }
  return api(cfg);
});

export function apiErr(detail) {
  const d = detail?.response?.data?.detail ?? detail;
  if (d == null) return "Something went wrong. Please try again.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((e) => e?.msg || JSON.stringify(e)).join(" ");
  if (typeof d?.msg === "string") return d.msg;
  return String(detail?.message || d);
}

export const fileUrl = (assetId) => (assetId ? `${API}/files/${assetId}` : null);

export async function runJob(path, body, { timeout = 420000, interval = 3000 } = {}) {
  const { data } = await api.post(path, body);
  if (!data?.job_id) return data;
  const start = Date.now();
  while (Date.now() - start < timeout) {
    await new Promise((r) => setTimeout(r, interval));
    const { data: j } = await api.get(`/ai/jobs/${data.job_id}`);
    if (j.status === "completed") return j.result;
    if (j.status === "failed") throw new Error(j.error || "AI job failed");
  }
  throw new Error("AI job timed out");
}

export const track = (name, props = {}) => {
  gaEvent(name, props);
  return api.post("/analytics/event", { name, props }).catch(() => {});
};

export default api;
